import { translate } from "base/shared/Localization";
import { CONVERSATION_ACTION } from "datamodel/Conversation/constants";
import { isDamageCoverageVisible } from "../damage-coverage/utils";
import { ACTIONS } from "./constants";

export const isVisitAvailable = (primaryAction) =>
  !(
    !primaryAction ||
    primaryAction === CONVERSATION_ACTION.REPLY_ENQUIRY ||
    primaryAction === CONVERSATION_ACTION.REPLY_INVITE
  );

const parseAction = ({
  action,
  connectionId = 0,
  dmgCoverageEnabled = false,
}) => {
  if (!action) {
    return null;
  }

  const { action: actionId, label } = action;
  const parsedAction = isDamageCoverageVisible(
    actionId,
    connectionId,
    dmgCoverageEnabled,
  )
    ? {
        ...ACTIONS.DAMAGE_COVERAGE,
        action: "damage_coverage",
        label: translate(
          "inbox.connections.actions.primary.get.damage.coverage",
        ),
      }
    : ACTIONS[actionId.toUpperCase()];
  return parsedAction && { label, ...parsedAction };
};

export const getActions = ({ actions, connectionId, dmgCoverageEnabled }) => ({
  primary: parseAction({
    action: actions.primary,
    connectionId,
    dmgCoverageEnabled,
  }),
  secondary: parseAction({
    action: actions.secondary,
  }),
});
